import { KForm, KDatePicker, KTextField, KTextarea, KTimePicker } from "kinnect-general";
import { formatDate } from "kinnect-formatters";
import { isSunday, parseISO } from "date-fns";
import {
	VCheckbox,
	VCol,
	VRow
} from "vuetify/lib";

export default KForm.extend( {
	name: "KCalendarEventForm",

	props: {
		event: Object,

		redirect: {
			...KForm.options.props.redirect,
			default: () => [ "back", { name: "calendar" } ]
		}
	},

	data: () => ( {
		formFields: {
			allDay: false,
			description: null,
			startDate: null,
			startTime: null,
			endDate: null,
			endTime: null,
			title: null
		},
		today: ( new Date() ).setHours( 0, 0, 0, 0 )
	} ),

	computed: {
		editing() {
			return Boolean( this.event );
		},

		formUrl() {
			return this.editing
				? `calendar/${this.event.id}`
				: "calendar";
		},

		todayFormatted() {
			return formatDate( this.today, "yyyy-MM-dd" );
		}
	},

	watch: {
		event: {
			handler( event ) {
				if ( event ) {
					Object.keys( this.formFields ).forEach( key => {
						if ( event.hasOwnProperty( key ) ) {
							this.formFields[key] = event[key];
						}
					} );
				}
			},
			immediate: true
		},

		"formFields.allDay"( val ) {
			if ( val ) {
				this.formFields.startTime = null;
				this.formFields.endTime = null;
			}
		}
	},

	methods: {
		isDateAllowed( date ) {
			return !isSunday( parseISO( date ) );
		}
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				action: this.formUrl,
				data: this.formFields,
				method: this.editing ? "put" : "post"
			}}
			on={this.$listeners}
		>
			<KTextField
				class="ml-blank-icon"
				label="Event Title*"
				required
				vModel={this.formFields.title}
				validationName="event title"
				validationRules="required"
			></KTextField>

			<VCheckbox
				color="accent"
				hideDetails
				label="All Day"
				vModel={this.formFields.allDay}
			></VCheckbox>

			<VRow>
				<VCol class="py-0" cols={12} sm={6}>
					<KDatePicker
						datePickerProps={{
							allowedDates: this.isDateAllowed,
							min: this.todayFormatted
						}}
						formatToken="EEE, MMM do, yyyy"
						textFieldProps={{
							label: "Start Date*",
							required: true,
							validationName: "start date",
							validationRules: "required"
						}}
						vModel={this.formFields.startDate}
					></KDatePicker>
				</VCol>

				<VCol class="py-0" cols={12} sm={6}>
					<KTimePicker
						disabled={this.formFields.allDay}
						textFieldProps={{
							label: "Start Time*",
							placeholder: this.formFields.allDay ? "All Day" : null,
							required: true,
							validationName: "start time",
							validationRules: { required: !this.formFields.allDay }
						}}
						vModel={this.formFields.startTime}
					></KTimePicker>
				</VCol>
			</VRow>

			<VRow>
				<VCol class="py-0" cols={12} sm={6}>
					<KDatePicker
						datePickerProps={{
							allowedDates: this.isDateAllowed,
							min: this.formFields.startDate ? this.formFields.startDate : this.todayFormatted
						}}
						formatToken="EEE, MMM do, yyyy"
						textFieldProps={{
							label: "End Date*",
							required: true,
							validationName: "end date",
							validationRules: "required"
						}}
						vModel={this.formFields.endDate}
					></KDatePicker>
				</VCol>

				<VCol class="py-0" cols={12} sm={6}>
					<KTimePicker
						disabled={this.formFields.allDay}
						textFieldProps={{
							label: "End Time*",
							placeholder: this.formFields.allDay ? "All Day" : null,
							required: true,
							validationName: "end time",
							validationRules: { required: !this.formFields.allDay }
						}}
						vModel={this.formFields.endTime}
					></KTimePicker>
				</VCol>
			</VRow>

			<KTextarea
				label="Event Description"
				prependIcon="comment"
				vModel={this.formFields.description}
			></KTextarea>
		</KForm>;
	}
} );
